import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { submit } from 'redux-form';
import { ContentProvider } from '@yuhu-inc/yuhui';
import TagManager from 'react-gtm-module';

import Auth from 'j-toker';
import { apiGet } from './helpers/ApiHelper';

import Confetti from 'react-dom-confetti';
import MediaQuery from 'react-responsive';
import 'App.css';

import TenantNavBar from 'navigation/TenantNavBar';
import ApplicationNavBar from 'components/tenant_application/applicationNavBar';
import SignatureNavBar from 'components/byesign/signatureNavBar';
import ChatPopup from 'components/tenant_app/components/ChatPopup';
import LoginDialog from 'navigation/LoginDialog';

import LeadInitialization from 'navigation/LeadInitialization';

import * as authentication from 'actions/authenticationActions';
import * as notification from 'actions/notificationActions';
import * as screenDimensionsActions from 'actions/screenDimensionsActions';
import * as userTypesActions from 'actions/userTypesActions';

import { MdRemoveCircle as UnverifiedIcon, MdCheck as VerifiedIcon } from 'react-icons/md';

import LoadingBar from 'react-redux-loading-bar';
import NotificationSystem from 'react-notification-system';
import Measure from 'react-measure';
import { BounceLoader } from 'halogenium';

import { localize } from 'react-localize-redux';

import { AccentColor } from 'helpers/AccentColorHelper';
import {
  getCompanyName,
  hostIsBoardwalk,
  hostIsBgoResidents,
  hostIsHollyburn,
} from 'helpers/CurrentWindowLocation';
import LandlordLogo from './components/shared/LandlordLogo';

import IncompatibleBrowser from './components/shared/IncompatibleBrowser';

import { isIE } from 'react-device-detect';
import styled from 'styled-components';
import { getTranslatedString, getCurrentLocale, contentNodes } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';

const POLL_FOR_ACTIVITY_IN_MS = 5 * 60 * 1000; // 5 mins

const StyledDiv = styled.div`
  height: 100%;
  width: 100%;
  text-align: center;
  background-color: ${(props) => (props.showBlackBorder ? '#000' : colors.DIALOG_BACKGROUND)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledDivBlackBorder = styled.div`
  padding: 20px;
  background-color: #000;
  border-radius: 25px;
`;

const TenantApp = connect(
  (store) => {
    return {
      showLoginForm: store.authentication.showLoginForm,
      showPage: store.authentication.showPage,
      showLoginDialog: store.authentication.showLoginDialog,
      shouldShowNonAuthPage: store.authentication.shouldShowNonAuthPage,
      updateSuccessNotice: store.notifications.updateSuccessNotice,
      updateFailureNotice: store.notifications.updateFailureNotice,
      message: store.notifications.message,
      showApplicationForm: store.authentication.showApplicationPage,
      showSignDocument: store.authentication.showSignaturePage,
      showLoader: store.notifications.showLoader,
      verbiage: store.notifications.verbiage,
      explosionCelebration: store.notifications.explosionCelebration,
      badgeIconForEvents: store.dashboard.badgeIconForEvents,
      landlordLogoThumbUrl: store.userTypes.landlordLogoThumbUrl,
      helpDocuments: store.userTypes.helpDocuments,
      privacyStatementLink: store.userTypes.privacyStatementLink,
      initialDialogOpen: store.userTypes.initialDialogOpen,
      mustAcceptTerms: store.userTypes.mustAcceptTerms,
      googleTagId: store.userTypes.googleTagId,
      landlordName: store.userTypes.landlordName,
      tenantOverview: store.dashboard.tenantOverview,
      propertyTypes: store.userTypes.propertyTypes,
      currentLanguage: store.locale.currentLanguage,
      translations: store.locale.translations,
    };
  },
  {
    ...authentication,
    ...notification,
    ...screenDimensionsActions,
    ...userTypesActions,
    submit,
  }
)(
  class App extends Component {
    constructor(props) {
      super(props);
      this.state = {
        sidebarOpen: false,
        sidebarDocked: true,
        sidebarIsOpen: true,
      };
      this.notificationSystem = null;
    }

    componentDidMount() {
      if (isIE) return;

      const initialised_width = this.refs.appContainer.offsetWidth;
      if (initialised_width < 750) {
        this.setState({ sidebarDocked: false, sidebarIsOpen: false });
      }

      if (browserHistory.getCurrentLocation().pathname !== '/') {
        apiGet(Auth.getApiUrl() + '/user/activity_poll').then((response) => {
          if (!response.active) {
            this.props.logUserOut();
            browserHistory.push('/');
            window.location.reload();
          }
        });
      }

      this.notificationSystem = this.refs.notificationSystem;
      this.activityPolling = this.pollActivity();
    }

    pollActivity = () => {
      return setInterval(() => {
        if (browserHistory.getCurrentLocation().pathname !== '/') {
          apiGet(Auth.getApiUrl() + '/user/activity_poll').then((response) => {
            if (!response.active) {
              this.props.logUserOut();
              browserHistory.push('/');
              window.location.reload();
            }
          });
        }
      }, POLL_FOR_ACTIVITY_IN_MS);
    };

    componentWillUnmount() {
      clearInterval(this.activityPolling);
    }

    translateMessage = (message) => {
      const { currentLanguage, translations } = this.props;
      if (message in translations.global[currentLanguage]) {
        return translations.global[currentLanguage][message];
      } else {
        return message;
      }
    };

    componentDidUpdate(prevProps) {
      if (isIE) return;

      if (this.props.updateSuccessNotice) {
        this.notificationSystem.addNotification({
          message: '',
          level: 'success',
          position: 'tr',
          autoDismiss: 5,
          children: (
            <div style={{ fontSize: '17px' }}>
              <span>
                <VerifiedIcon style={{ verticalAlign: 'text-top' }} />
                &nbsp;&nbsp;
                {this.props.message
                  ? this.translateMessage(this.props.message)
                  : getTranslatedString('successfullyUpdated')}
              </span>
            </div>
          ),
        });
        this.props.hideSuccess();
      } else if (this.props.updateFailureNotice) {
        this.notificationSystem.addNotification({
          message: '',
          level: 'error',
          position: 'tr',
          autoDismiss: 5,
          children: (
            <div style={{ fontSize: '17px' }}>
              <span>
                <UnverifiedIcon style={{ verticalAlign: 'text-top' }} />
                &nbsp;&nbsp;
                {this.props.message
                  ? this.translateMessage(this.props.message)
                  : getTranslatedString('unknownError')}
              </span>
            </div>
          ),
        });
        this.props.hideFailure();
      }

      if (this.props.googleTagId && this.props.googleTagId !== prevProps.googleTagId) {
        const tagManagerArgs = {
          gtmId: this.props.googleTagId,
        };

        TagManager.initialize(tagManagerArgs);
      }
    }

    addNotification = () => {
      this.notificationSystem.addNotification(this.props.notificationBody);
    };

    onSetSidebarOpen(open) {
      this.setState({ sidebarOpen: open });
    }

    dockSidebar(dock, open_or_closed) {
      this.setState({ sidebarDocked: dock, sidebarIsOpen: open_or_closed });
    }

    _onResize = (width, height) => {
      if (width > 750) {
        this.setState({ sidebarDocked: true, sidebarIsOpen: true });
      } else {
        this.setState({ sidebarDocked: false, sidebarIsOpen: false });
      }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (isIE) return;

      this.setState({
        children: nextProps.children,
      });
    }

    handleChange = (event, index, value) => this.props.selectRoute({ value });

    render() {
      if (isIE) {
        return <IncompatibleBrowser />;
      }

      // TODO: temporarily adding this as we do not have all splash screens
      const newPaths = ['/', '/user_onboarding', '/tenant_password_reset'];
      const noLogoPaths = ['/vendor_maintenance_ticket'];
      const applyPath = ['/apply_and_sign_up'];
      const surveyPath = ['/survey'];
      const path = browserHistory.getCurrentLocation().pathname;
      const isMobile = window.matchMedia('(max-width: 500px)').matches;
      const heightOfApplyAndSignUp = window.matchMedia('(max-height: 883px)').matches;

      const showSplashScreenTemplate = this.props.showLoginForm || this.props.shouldShowNonAuthPage;
      const showApplicationForm = this.props.showApplicationForm;
      const showSignDocument = this.props.showSignDocument;

      const showTenantMaintenanceVerification =
        browserHistory.getCurrentLocation().pathname === '/tenant_maintenance_verification';

      const showSplashWithBackground =
        (showSplashScreenTemplate && newPaths.includes(path) && hostIsBgoResidents()) ||
        showTenantMaintenanceVerification;
      const showSplashBlackBorder =
        showSplashScreenTemplate && newPaths.includes(path) && hostIsBoardwalk();
      const preventLogoCrop = applyPath.includes(path) && heightOfApplyAndSignUp;
      const showSplashCentered =
        !showSplashWithBackground && !showSplashBlackBorder && showSplashScreenTemplate;
      const hideLandlordLogo = noLogoPaths.includes(path);
      const isSurvey = surveyPath.includes(path);

      const confettiConfig = {
        angle: 90,
        spread: 78,
        startVelocity: 20,
        elementCount: 146,
        decay: 0.96,
      };

      let customSquareImage = null;
      if (hostIsBgoResidents()) {
        customSquareImage = '77_gerrard_square.jpg';
      } else if (hostIsHollyburn()) {
        customSquareImage = 'hollyburn_square.png';
      }

      const tenantVerbiage =
        this.props.propertyTypes === 'commercial'
          ? this.props.translate('pageTitle.tenant')
          : this.props.translate('pageTitle.resident');

      let css = `
        .selected {
          border-color: ${AccentColor()} !important;
        }
        .mobile-menu {
          border-top: solid ${AccentColor()} 2px;
        }`;

      const backgroundColor = showSplashBlackBorder && isMobile ? '#000' : colors.DIALOG_BACKGROUND;

      const lang = getCurrentLocale();

      const content = {
        contentNodes,
        theme: {
          colors: {
            primary: {
              light: colors.LIGHT_BLUE_GREY,
              dark: colors.ULTRAMARINE_BLUE,
            },
          },
        },
      };

      return (
        <ContentProvider lang={lang} content={content}>
          <div style={{ height: '100%' }} ref="appContainer">
            <Helmet>
              <title>
                {getCompanyName()} | {tenantVerbiage.props.children}
              </title>
              <link
                rel="icon"
                type="image/png"
                href={customSquareImage || this.props.landlordLogoThumbUrl || '/blank.ico'}
              />
              <link
                rel="apple-touch-icon"
                type="image/png"
                href={customSquareImage || this.props.landlordLogoThumbUrl || '/blank.ico'}
              />
            </Helmet>
            <Helmet
              meta={[
                {
                  name: 'apple-mobile-web-app-title',
                  content: `${getCompanyName()}`,
                },
              ]}
            />
            <style>{css}</style>
            <header>
              <MediaQuery query="(max-device-width: 750px)">
                <LoadingBar
                  style={{
                    height: '4px',
                    zIndex: '5000',
                    backgroundColor: AccentColor(),
                  }}
                />
              </MediaQuery>
              <MediaQuery query="(min-device-width: 751px)">
                <LoadingBar
                  style={{
                    height: '2px',
                    zIndex: '5000',
                    backgroundColor: AccentColor(),
                  }}
                />
              </MediaQuery>
            </header>
            <NotificationSystem ref="notificationSystem" />
            <LoginDialog isOpen={this.props.showLoginDialog} />
            <Measure
              onMeasure={(dimensions) => {
                this.props.changeDimensions(dimensions.width, dimensions.height);
                this._onResize(dimensions.width, dimensions.height);
              }}
            >
              <div style={{ width: '100%', height: '100%' }}>
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    right: '50%',
                    zIndex: 100000,
                  }}
                >
                  <Confetti active={this.props.explosionCelebration} config={confettiConfig} />
                </div>

                {this.props.mustAcceptTerms && (
                  <LeadInitialization
                    mustAcceptTerms={this.props.mustAcceptTerms}
                    landlordName={this.props.landlordName}
                    initialDialogOpen={this.props.initialDialogOpen}
                    currentRoute={browserHistory.getCurrentLocation().pathname}
                    submit={this.props.submit}
                    privacyStatementLink={this.props.privacyStatementLink}
                  />
                )}

                {this.props.showLoader && (
                  <div
                    style={{
                      position: 'relative',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      zIndex: '500',
                    }}
                  >
                    <p
                      style={{
                        textAlign: 'center',
                        marginTop: '30px',
                        width: '60px',
                        margin: 'auto',
                      }}
                    >
                      <BounceLoader color={AccentColor()} />
                    </p>

                    <p
                      style={{
                        textAlign: 'center',
                        marginTop: '15px',
                        marginBottom: '15px',
                      }}
                    >
                      {this.props.translate('bearWithUs')} {this.props.verbiage}.
                    </p>
                  </div>
                )}
                {!this.props.showPage &&
                  !this.props.showSignDocument &&
                  !this.props.showSplashScreenTemplate &&
                  !this.props.shouldShowNonAuthPage &&
                  !this.props.showApplicationForm &&
                  !this.props.showLoginForm && (
                    <div
                      style={{
                        position: 'relative',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: '500',
                      }}
                    >
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: '30px',
                          width: '60px',
                          margin: 'auto',
                        }}
                      >
                        <BounceLoader color={AccentColor()} />
                      </div>
                      <p
                        style={{
                          textAlign: 'center',
                          marginTop: '15px',
                          marginBottom: 0,
                        }}
                      >
                        {this.props.translate('believeHalfway')}
                      </p>
                      <p
                        style={{
                          textAlign: 'center',
                          marginTop: '3px',
                          fontSize: '12px',
                        }}
                      >
                        -Theodore Roosevelt
                      </p>
                    </div>
                  )}

                {this.props.showPage && !showSignDocument && (
                  <div style={{ height: '100%', width: '100%' }}>
                    <div className="body-container flex-flexible flex-stack slide">
                      <TenantNavBar
                        dockSidebar={this.dockSidebar.bind(this)}
                        sidebarIsOpen={this.state.sidebarIsOpen}
                        logUserOut={this.props.logUserOut}
                        helpDocuments={this.props.helpDocuments}
                        privacyStatementLink={this.props.privacyStatementLink}
                        showSideBar={true}
                      />
                      {this._renderChatPopup()}
                      {this.props.children}
                    </div>
                  </div>
                )}

                {showSplashWithBackground && this.props.children}

                {showSplashScreenTemplate && !showSplashWithBackground && (
                  <div
                    style={{
                      height:
                        showTenantMaintenanceVerification || preventLogoCrop || isSurvey
                          ? 'auto'
                          : '100%',
                      width: '100%',
                      textAlign: 'center',
                      backgroundColor: backgroundColor,
                    }}
                    ref="appContainer"
                  >
                    <div
                      style={{
                        height:
                          showTenantMaintenanceVerification || preventLogoCrop || isSurvey
                            ? 'auto'
                            : '100%',
                        display: 'inline-flex',
                        padding: '15px 0',
                        overflow: 'scroll',
                        width: '100%',
                      }}
                    >
                      <StyledDiv showBlackBorder={isMobile && showSplashBlackBorder}>
                        {showSplashBlackBorder && (
                          <StyledDivBlackBorder>
                            <LandlordLogo
                              fontSize="90px"
                              maxWidth="273px"
                              height="100px"
                              textHeight="70px"
                            />
                            {this.props.children}
                          </StyledDivBlackBorder>
                        )}
                        {showSplashCentered && (
                          <Fragment>
                            {!hideLandlordLogo && (
                              <LandlordLogo
                                fontSize="90px"
                                maxWidth="273px"
                                height="100px"
                                textHeight="70px"
                              />
                            )}
                            {this.props.children}
                          </Fragment>
                        )}
                      </StyledDiv>
                    </div>
                  </div>
                )}

                {showApplicationForm && (
                  <div className="body-container" style={{ height: '100%' }}>
                    <ApplicationNavBar />
                    <div className="row" style={{ paddingTop: '65px', height: '100%' }}>
                      {this.props.children}
                    </div>
                  </div>
                )}

                {showSignDocument && (
                  <div style={{ height: '100%', width: '100%' }}>
                    <div className="body-container" style={{ height: '100%' }}>
                      <SignatureNavBar />
                      <div
                        className="row"
                        style={{
                          padding: '53px 0px 88px',
                          height: '100%',
                          overflow: 'auto',
                        }}
                      >
                        {this.props.children}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Measure>
          </div>
        </ContentProvider>
      );
    }

    _renderChatPopup = () => {
      if (!this.props.tenantOverview.show_messaging) return;
      if (this.props.tenantOverview.is_prospect) return;

      return (
        <ChatPopup
          chatName={this.props.tenantOverview.landlord_name}
          chatAvatar={this.props.tenantOverview.landlord_avatar}
          cotenantId={this.props.tenantOverview.cotenant_id}
        />
      );
    };
  }
);

export default localize()(TenantApp);
